import { render, staticRenderFns } from "./Japanese.vue?vue&type=template&id=970c9adc&"
import script from "./Japanese.vue?vue&type=script&lang=ts&"
export * from "./Japanese.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports